/*******************************************************************************
  DevPage.js

  Author: Advait

  This file should be used for developement and testing code only
*******************************************************************************/

import React, { Component } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { createScheduleItem } from "../graphql/mutations";
import { getTenantsWithSites } from "../apihelpers/graphqlhelpers";
import DownloadUsageReport from "../components/DownloadUsageReport";
import SelectTenant from "../components/SelectTenant";
import SelectSiteSimple from "../components/SelectSiteSimple";
import { connect } from "react-redux";
import "../index.css";

const listSchedules = `query ListScheduleItems(
  $filter: ModelScheduleItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listScheduleItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      siteId
      enabled
      type
      day
      startTime
      duration
    }
    nextToken
  }
}
`;

class DevPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refreshCount: 0, // increment to cause the SelectSiteSimple to refresh from database
      tenants: [],
      createSchedule: false,
    };
    this.createSecurityPatrolSchedules = this.createSecurityPatrolSchedules.bind(this);
  }

  async componentDidMount() {
    let tenants = await getTenantsWithSites(false);
    this.setState({ tenants: tenants });
    this.updateSchedules();
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedSiteId !== prevProps.selectedSiteId) {
      this.updateSchedules();
    }
  }

  //***************************************************************************
  // Called when user has saved new values in the Site table.
  // Ask the SelectSiteSimple component to refresh its values from
  // the database so we don't get any stale data when user switches sites.
  //***************************************************************************
  handleThresholdsSaved() {
    this.setState({ refreshCount: this.state.refreshCount + 1 });
  }

  /**
   * queries the Schedule dynamodb table and then handles the state change
   */
  async updateSchedules() {
    // get the schedule items from grphql query
    // filter based on type and siteId
    let userRequestedItemType = "security_patrol";
    let userRequestedSite = this.props.selectedSiteId;
    let siteAndTypeFilter = {
      siteId: {
        eq: userRequestedSite,
      },
      type: {
        eq: userRequestedItemType,
      },
    };
    let list_schedules = await API.graphql(
      graphqlOperation(listSchedules, {
        filter: siteAndTypeFilter,
        limit: 500,
      })
    );
    let allschedules = list_schedules.data.listScheduleItems.items;
    //***************************************************************************
    // If the token is null that means there is no more data in the database,
    // but if the there is token then following code will run until we recieve the
    // null token.
    //***************************************************************************
    let token = list_schedules.data.listScheduleItems.nextToken;
    while (token !== null) {
      let newSchedules = {};
      newSchedules = await API.graphql(
        graphqlOperation(listSchedules, {
          filter: siteAndTypeFilter,
          limit: 500,
          nextToken: token,
        })
      );
      token = newSchedules.data.listScheduleItems.nextToken;
      allschedules = allschedules.concat(newSchedules.data.listScheduleItems.items);
    }

    // If the scheduleType is security_patrol and there are no schedule items then create
    // 7 schedule items for security_patrol.
    if (allschedules.length === 0) {
      this.setState({ createSchedule: true });
    } else {
      this.setState({ createSchedule: false });
    }
  }

  //***************************************************************************
  // If the selected site does not have security patrol schedules, create new
  // schedule and update the UI and display the content as per latest states.
  //***************************************************************************
  async createSecurityPatrolSchedules() {
    console.log(
      "creating security patrol schedules for site with siteID: ",
      this.props.selectedSiteId
    );
    var i = 0;
    do {
      let ScheduleItem = {
        siteId: this.props.selectedSiteId,
        enabled: false,
        day: (i % 7).toString(),
        tid: this.props.selectedTenantId,
        startTime: "00:30",
        type: "security_patrol",
        duration: "4:00",
      };
      console.log("ScheduleItem: ", ScheduleItem);
      try {
        const response = await API.graphql(
          graphqlOperation(createScheduleItem, { input: ScheduleItem })
        );
        console.log("response", response);
        if (response !== "") {
          console.log("schedule created successfully.");
        }
      } catch (e) {
        console.log(e);
      }
      i++;
    } while (i < 7);
    this.updateSchedules();
  }

  //***************************************************************************
  // render the UI
  //***************************************************************************
  render() {
    return (
      <div className="fullPageDiv">
        <h3>Dev Page</h3>
        <SelectTenant />
        {this.props.selectedTenantId ? <SelectSiteSimple /> : null}
        {this.props.selectedTenantId && this.props.selectedSiteId ? (
          <div className="individualContainer">
            <table className="individualContainerTable">
              <tbody>
                <tr>
                  <td className="individualContainerTitleColumn" valign="top">
                    <h4 className="individualContainerTitleHeading">
                      Security Patrol Schedule
                    </h4>
                  </td>
                  <td>
                    {this.state.createSchedule ? (
                      <button
                        className="saveButton"
                        onClick={this.createSecurityPatrolSchedules}
                      >
                        Create Security Patrol Schedule
                      </button>
                    ) : (
                      <h6>Security Patrol Schedule Items are already present</h6>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : null}

        <DownloadUsageReport></DownloadUsageReport>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTenantId: state.selectedSite.tenantId,
  selectedSiteId: state.selectedSite.siteId,
});

export default connect(mapStateToProps)(DevPage);
